module.exports = __webpack_public_path__ + "media/images/victory-ebfe8b8d366a2d2277bc6084436284c3.png";